function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.875 5.90625V3.9375",
  stroke: "#443E99",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.125 17.0625V15.0938",
  stroke: "#443E99",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.90625 7.875H3.9375",
  stroke: "#443E99",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0625 13.125H15.0938",
  stroke: "#443E99",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5.82409 10.5332L4.89714 11.4602C4.28144 12.0759 3.93555 12.9109 3.93555 13.7816C3.93555 14.2128 4.02047 14.6397 4.18546 15.038C4.35045 15.4363 4.59228 15.7983 4.89714 16.1031C5.202 16.408 5.56392 16.6498 5.96224 16.8148C6.36056 16.9798 6.78748 17.0647 7.21862 17.0647C8.08935 17.0647 8.92441 16.7188 9.54011 16.1031L10.4671 15.1762",
  stroke: "#443E99",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1762 10.4671L16.1031 9.54011C16.7188 8.92441 17.0647 8.08935 17.0647 7.21862C17.0647 6.3479 16.7188 5.51283 16.1031 4.89714C15.4874 4.28144 14.6524 3.93555 13.7816 3.93555C12.9109 3.93555 12.0759 4.28144 11.4602 4.89714L10.5332 5.82409",
  stroke: "#443E99",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgNotConnected = function SvgNotConnected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotConnected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notConnected.5e2c8ea7.svg";
export { ForwardRef as ReactComponent };